export const borderData = {
  bottomLeft: 'outside-corner-lateral',
  topLeft: 'inside',
  topRight: 'outside-corner-upper',
} as const;
